<template>
  <div v-bind:class="{ 'phone-app': true, hide: !phoneCall.ongoing }" v-if="!remove">
    <pulse-loader></pulse-loader>
    <img src="https://s3.amazonaws.com/37assets/svn/765-default-avatar.png" />
    <div class="status">CALLING...</div>
    <div class="name">{{ phoneCall.name }}</div>
    <div class="phone">{{ phoneCall.phone }}</div>
    <div class="row">
      <div class="small-6 columns">
        <a class="button margin-R" href="javascript:;" @click="toggleMute">
          <i v-bind:class="{
            'fas fa-fw': true,
            'fa-microphone-slash': isMute,
            'fa-microphone': !isMute
          }"></i>
        </a>
      </div>
      <div class="small-6 columns">
        <a class="button error margin-L" href="javascript:;" @click="endCall">
          <i class="fas fa-phone fa-fw fa-rotate-270"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import PulseLoader from '@/components/Partials/LoadingAnimation/Pulse'
export default {
  name: 'phone-app',
  components: { PulseLoader },data () {
    return {
      remove: false
    }
  },
  computed: {
    isMute () { return this.$store.state.phone.isMute },
    phoneCall () { return this.$store.state.phone },
    _route () { return this.$route.name }
  },
  methods: {
    endCall () {
      let self = this
      self.$plugins.phone.endCall(self)
    },
    toggleMute () {
      let self = this
      self.$plugins.phone.toggleMute(self)
    }
  },
  watch: {
    _route: function (value) { this.remove = value === 'ProviderPrintPlacard' }
  },
}
</script>

<style lang="scss" scoped>

.phone-app{
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 99;
  background-color: #444;
  border-radius: 5px;
  padding: 15px 15px;
  color: #fff;
  box-shadow: 0 4px 8px rgba(0,0,0,0.25);
  text-align: center;
  transition: all 250ms;

  &.hide{
    top: -300px
  }

  & img {
    position: absolute;
    top: 20px;
    left: calc(50% - 25px);
    width: 50px;
    height: 50px;
    background-color: #ddd;
    border-radius: 50%;
  }

  & .status{
    display: block;
    font-style: normal;
    font-size: 10px;
    font-weight: 700;
    margin-top: 5px;
  }

  & .name{
    font-size: 16px;
    font-weight: 700;
    color: #eee;
  }

  & .phone {
    font-size: 12px;
    font-weight: 700;
    margin-top: 3px;
    margin-bottom: 10px;
  }

  & .button{
    padding: 0;
    width: 45px;
    height: 45px;
    line-height: 45px;
    border-radius: 50%;
    text-align: center;

    & i { line-height: inherit; }

    &.margin-L { margin-left: 5px; }
    &.margin-R { margin-right: 5px; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/App/PhoneApp.vue